








































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import QTable from 'quasar/src/components/table/QTable.js';
import { DatePresetTypes, Filter, FilterTypes, NumberPresetTypes } from '@/modules/common/filter/filter'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { UserCollectionType } from '@/modules/user/models/user-collection.model'
import AdminUserTableRow from '@/modules/user/components/admin/table/AdminUserTableRow.vue'
import { adminUserTableColumn } from '@/modules/user/models/columns/admin-user-table.column'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import AdminRoleSearchFilter from '@/modules/role/components/admin/AdminRoleSearch.filter.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminCreateUserDialog from '@/modules/user/components/admin/AdminCreateUserDialog.vue'
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'
import { AdminUserRoutes } from '@/modules/user/routes/admin-user.route'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست کاربران'
  },
  metaInfo: {
    title: 'لیست کاربران'
  },
  components: {
    TableExportButton,
    BaseButton,
    PaginationWithInput,
    FilterRow,
    TesTable
  }
})
export default class UsersIndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {

  constructor(
    private readonly adminUserRoutes: AdminUserRoutes
  ) {
    super()
  }

  @Prop() private users!: UserCollectionType
  private rowComponent = AdminUserTableRow
  private columns: QTable['columns'] = adminUserTableColumn()
  myModel = true

  protected get model() {
    return this.users
  }

  private filters = [
    new Filter({
      type: FilterTypes.Custom,
      key: 'roles',
      title: 'نقش',
      component: AdminRoleSearchFilter
    }),
    new Filter({
      type: FilterTypes.NumericRange,
      keys: {
        from: 'wallet_amount_gt',
        to: 'wallet_amount_lt'
      },
      min: 0,
      max: Infinity,
      title: 'کیف پول کاربر',
      presets: [
        { label: 'دارای موجودی', from: 1, to: null },
        NumberPresetTypes.range
      ]
    }),
    new Filter({
      type: FilterTypes.NumericRange,
      keys: {
        from: 'writer_wallet_amount_gt',
        to: 'writer_wallet_amount_lt'
      },
      min: 0,
      max: Infinity,
      title: 'کیف پول نویسنده',
      presets: [
        { label: 'دارای موجودی', from: 1, to: null },
        NumberPresetTypes.range
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      keys: {
        from: 'created_at_from',
        to: 'created_at_to'
      },
      title: 'تاریخ عضویت',
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      keys: {
        from: 'last_login_at_from',
        to: 'last_login_at_to'
      },
      title: 'تاریخ آخرین فعالیت',
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ]
    })
  ]

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private openCreateUserDialog() {
    this.$q.dialog({
      component: AdminCreateUserDialog
    })
  }
}
